import React from 'react';

import TablePanelBase from 'main/components/panel/TablePanel';

const defaultProps = {
    headerColumnStyle: { fontWeight: 600 },
    tableWrapperStyle: { whiteSpace: 'pre' },
    rowHoverable: false,
    showScroll: true,
    hideToolbar: true,
    tableSize: 'medium'
};

const TablePanel = (props) => {
    return <TablePanelBase {...{ ...defaultProps, ...props }} />;
};

export default TablePanel;
